import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-ModuloSolicitudes',
  template: `
    <p>
      modulo-solicitudes works!
    </p>
  `,
  styles: [
  ]
})
export class ModuloSolicitudesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
